import React from "react";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../../HeaderAll";

function HeaderSalesman({ info, infoData }) {

  const styf = { fontWeight: "1200" };


  return (
    <Grid item container
      justifyContent="center"
      style={{
        paddingTop: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular",
      }}>
      <HeaderAll Report={true} found={info} />

      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
        <Grid item xs={12} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem", paddingBottom: "0.5rem",
          borderRadius: "5px", textAlign: "center",
        }}
        >
          <div style={styf}>
            {infoData.title}
          </div>
        </Grid>
      </Grid>
      <Grid item container style={{
        fontFamily: "Amiri-Regular", padding: "0.3rem", border: "solid 2px",
        borderRadius: "5px", direction: "rtl",
      }}
      >
        <Grid item xs={12} container>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            {"الفرع"}/{" "} {infoData.branch}
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            {"المندوب"} /{" "} {infoData.salesman}
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {"نوع العمولة"} /{" "}   {infoData.omlatype}
          </Grid>
          <Grid item xs={3} style={{ textAlign: "right" }}>
            {"نوع الفاتورة"} /{" "}   {infoData.invtype}
          </Grid>
          <Grid item xs={3} style={{ textAlign: "right" }}>
            {"نوع الدفع"} /{" "}   {infoData.paytype}
          </Grid>
          <Grid item xs={3} style={{ textAlign: "right" }}>
            {"الحساب"} /{" "}   {infoData.bank}
          </Grid>
          <Grid item xs={3} style={{ textAlign: "right" }}>
            {"من تاريخ"} /{" "}   {infoData.fDate}
          </Grid>
          <Grid item xs={3} style={{ textAlign: "right" }}>
            {"الى تاريخ"} /{" "}   {infoData.tDate}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
export default HeaderSalesman;